export class ValidatorsTerms {
  public static REQUIRED = 'REQUIRED';
  public static NAMES_VALIDATORS = 'NAMES_VALIDATORS';
  public static MORE_THAN_ZERO = 'MORE_THAN_ZERO';
  public static REQUIRED_MORE_THAN_ZERO = 'REQUIRED_MORE_THAN_ZERO';
  public static REQUIRED_AT_LEAST_ZERO = 'REQUIRED_AT_LEAST_ZERO';
  public static AT_LEAST_ZERO = 'AT_LEAST_ZERO';
  public static SCI_NOTATION = 'SCI_NOTATION';
  public static REQUIRED_SCI_NOTATION = 'REQUIRED_SCI_NOTATION';
  public static SCI_NOTATION_MORE_THAN_ZERO = 'SCI_NOTATION_MORE_THAN_ZERO';
  public static REQUIRED_SCI_NOTATION_MORE_THAN_ZERO = 'REQUIRED_SCI_NOTATION_MORE_THAN_ZERO';
  public static REQUIRED_SCI_NOTATION_AT_LEAST_ZERO_MAX_ONE =
    'REQUIRED_SCI_NOTATION_AT_LEAST_ZERO_MAX_ONE';
  public static REQUIRED_SCI_NOTATION_MORE_THAN_ZERO_MAX_90 =
    'REQUIRED_SCI_NOTATION_MORE_THAN_ZERO_MAX_90';
  public static SCI_NOTATION_AT_LEAST_ZERO = 'SCI_NOTATION_AT_LEAST_ZERO';
  public static REQUIRED_SCI_NOTATION_AT_LEAST_ZERO = 'REQUIRED_SCI_NOTATION_AT_LEAST_ZERO';
  public static REQUIRED_FUNCTION_LENGTH = 'REQUIRED_FUNCTION_LENGTH';
}
